import { APP_INITIALIZER, ErrorHandler, NgModule, NO_ERRORS_SCHEMA } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HttpBackend, HttpClient, HttpClientModule } from "@angular/common/http";
import { BrowserModule } from "@angular/platform-browser";
import { HashLocationStrategy, LocationStrategy } from "@angular/common";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AppRoutingModule } from "./app-routing.module";
import { AppCommonModule, PrimengModule } from "./modules";
import { AppComponent } from "./app.component";
import { AppMaintenanceComponent } from "./pages/maintain/app.maintenance";
import { AppErrorComponent } from "./pages/error/app.error.component";
import { AppAccessdeniedComponent } from "./pages/access/app.accessdenied.component";
import { NgHttpLoaderModule } from "ng-http-loader";
import { UserSettingsResolver } from './shared/resolver/user-settings.resolver';
import { AppAssociationComponent } from './pages/association/app.association.component';
import { AngularDraggableModule } from "angular2-draggable";
import { ClipboardModule } from '@angular/cdk/clipboard';
import { DatePipe } from '@angular/common';
import { NgxDaterangepickerMd } from "ngx-daterangepicker-material";
import { ToastModule } from 'primeng/toast';
import { initializeAppFactory } from './app.config';
import { EndUserLicenseAgreementComponent } from './pages/end-user-license-agreement/end-user-license-agreement.component';
import { SharedFilterService } from "./shared/service/filter-service/shared-filter.service";
import { AuthClientConfig, AuthModule } from "@auth0/auth0-angular";
import { environment } from "../environments/environment";
import { Auth0ErrorComponent } from './pages/auth0-error/auth0-error/auth0-error.component';
import { PageBreakComponent } from './pages/page-break/page-break/page-break.component';
import { AppNotfoundComponent } from './pages/not-found/app-notfound/app-notfound.component';
import { FormatNumberWithSymbolPipe } from "./shared/pipe/format-number-with-symbol.pipe";
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';
import {definePreset} from '@primeng/themes';
import { MyPreset } from "../style";


@NgModule({
    imports: [
        BrowserModule,
        AppRoutingModule,
        FormsModule,
        HttpClientModule,
        BrowserAnimationsModule,
        ReactiveFormsModule,
        AppCommonModule,
        PrimengModule,
        NgHttpLoaderModule.forRoot(),
        NgxDaterangepickerMd.forRoot(),
        AngularDraggableModule,
        ClipboardModule,
        AuthModule.forRoot({
            domain: environment.auth.domain,
            clientId: environment.auth.clientId,
          }),
        DatePipe,ToastModule

    ],
    declarations: [
        AppAccessdeniedComponent,
        AppAssociationComponent,
        AppComponent,
        AppErrorComponent,
       // AppLoginComponent,
        AppMaintenanceComponent,
       EndUserLicenseAgreementComponent,
       Auth0ErrorComponent,
       PageBreakComponent,
       AppNotfoundComponent,
    ],
    providers: [
        providePrimeNG({
            ripple: true,
            theme: {
              preset: MyPreset, // Use custom blue preset
              options: {
                prefix: 'p',
                // darkModeSelector: 'system',
                cssLayer: false,
                darkModeSelector: false || 'none'
              }
            }
          }),    
        UserSettingsResolver,
        FormatNumberWithSymbolPipe,
        SharedFilterService,
        { provide: LocationStrategy, useClass: HashLocationStrategy }
        , UserSettingsResolver, ErrorHandler, DatePipe, {
        provide: APP_INITIALIZER,
        useFactory: initializeAppFactory,
        deps: [HttpBackend, AuthClientConfig],
        multi: true,
    },],
    bootstrap: [AppComponent],
    schemas: [NO_ERRORS_SCHEMA],
    exports: [FormsModule],
})
export class AppModule {
}

